export const SELECT_MODE = 'SELECT_MODE';
export const TIMELINE_ADVANCED_MODIFIED = 'TIMELINE_ADVANCED_MODIFIED';
export const PREVIEW_MODE = 'PREVIEW_MODE';
export const SET_VOICE_OVER_PREVIEW='SET_VOICE_OVER_PREVIEW';
